
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dQUV0", function(module, exports) {

$parcel$export(module.exports, "WatchSettingsOverflowMenuShortcut", () => $e9ccf9ec658c8b94$export$2ba94ece6826c60);

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $ipPpS = parcelRequire("ipPpS");

var $gqqjz = parcelRequire("gqqjz");

var $d9tcB = parcelRequire("d9tcB");
var $bQm3c = parcelRequire("bQm3c");

var $j00wp = parcelRequire("j00wp");

var $jle6C = parcelRequire("jle6C");

var $hpr9b = parcelRequire("hpr9b");

var $pskhd = parcelRequire("pskhd");
const $e9ccf9ec658c8b94$export$2ba94ece6826c60 = ({ openWatchSettingsMenu: openWatchSettingsMenu, contentId: contentId, contentType: contentType })=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    const { data: data } = (0, $j1Ss3.useQuery)((0, $hpr9b.getWatchDialogQuery)(), {
        variables: {
            contentId: contentId
        },
        skip: !isLicensed
    });
    const updateQueryHandler = (cache, watchTarget, newDataValue)=>{
        const query = (0, $hpr9b.getWatchDialogQuery)();
        const contentData = cache.readQuery({
            query: query,
            variables: {
                contentId: contentId
            }
        });
        // We only update the cache with UpdateContentType.CONTENT if the watch/unwatch mutations are fired via shortcut
        if (watchTarget === (0, $jle6C.UpdateContentType).CONTENT) contentData.singleContent.currentUserIsWatching = newDataValue;
        cache.writeQuery({
            query: query,
            data: contentData
        });
    };
    const { isCurrentUserWatching: isWatchingContent, isWatchingChildren: isWatchingChildren, hasAncestorWatchingChildren: hasAncestorWatchingChildren, isWatchingSpace: isWatchingSpace } = (0, $pskhd.processWatchData)(data);
    const shortcutParams = {
        isWatchingContent: isWatchingContent,
        isWatchingChildren: isWatchingChildren,
        hasAncestorWatchingChildren: hasAncestorWatchingChildren,
        isWatchingSpace: isWatchingSpace
    };
    if (!isLicensed) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $j00wp.WatchDialogShortcut), {
            contentId: contentId,
            contentType: contentType,
            flagsContainer: flags,
            openDialog: openWatchSettingsMenu,
            updateQueryHandler: updateQueryHandler,
            params: shortcutParams
        }));
};

});


//# sourceMappingURL=WatchSettingsOverflowMenuShortcut.8a5ae35b.js.map
